import { makeAutoObservable, runInAction } from "mobx";
import { State } from "../../enum/state";
import http from "../../services/http";

class AdminTariffsStore {
  data?: IObject[];

  item?: IObject;

  lookups?: ILookups;

  isLoading = false;

  state: State = "None";

  private api = "/tariffs";

  async findCreate() {
    this.isLoading = true;
    try {
      const result = await http.get(this.api + `/create`);
      runInAction(() => {
        this.lookups = result.data;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async findAll() {
    const result = await http.get(this.api);
    runInAction(() => {
      this.data = result.data.data;
    });
  }

  async onCreate(values: any) {
    this.isLoading = true;
    try {
      await http.post(this.api, values);
      await this.findAll();
      runInAction(() => {
        this.state = "None";
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async onUpdate(values: any) {
    this.isLoading = true;
    try {
      await http.put(this.api + `/${this.item?.id}`, values);
      await this.findAll();
      runInAction(() => {
        this.state = "None";
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async onRead(id: string) {
    this.isLoading = true;
    try {
      const result = await http.get(this.api + `/${id}`);
      runInAction(() => {
        this.item = result.data.data;
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async onDelete(id: string) {
    this.isLoading = true;
    try {
      await http.delete(this.api + `/${id}`);
      runInAction(() => {
        if (this.data) {
          this.data = this.data.filter((e) => e.id !== id);
        }
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export default AdminTariffsStore;

interface IObject {
  id: string;
  name: string;
  systemIdentifier: string;
  price: number;
  oldPrice: number;
  limits: ILimit[];
  tariffCountryPrices: ITariffCountryPrice[];
  policies: IPolicy[];
  createdAt: Date;
}

interface ILimit {
  id: string;
  key: IKey;
  value: number;
  createdAt: Date;
}

interface ITariffCountryPrice {
  id: string;
  price: number;
  oldPrice: number;
  country: ICountry;
}

interface IKey {
  value: string;
  title: string;
}

interface IPolicy {
  id: string;
  name: string;
  value: number;
  description: string;
  routes: IRoute[];
}

interface ICountry {
  id: string;
  name: string;
  isoCode: string;
}

interface IRoute {
  id: string;
  name: string;
  url: string;
}

interface ILookups {
  policies: IPolicy[];
  limits: IKey[];
  countries: ICountry[];
}